/**
 * @author Yakov.Gushchin
 * @version 1.0.0
 */
import ICommonTranslationExport from '../../types/common/export';

const initTranslationExport: ICommonTranslationExport = {
    cancel: '',
    export: '',
    popupTitle: '',
    popupText: '',
};

export default initTranslationExport;
